export const GA_SCOUT_EXTEND_ACTION = "scout_scout_extended";
export const GA_SCOUT_ASSENT_ACTION = "entry_scout-undefined";
export const GA_INNER_CASSETTE_ACTION = "jsl__scout_modal_inner_cassette";
export const GA_SCOUT_SHOW_MODAL_BUTTON = "jsl_modal_open";
export const GA_SCOUT_SHOW_MODAL_BUTTON_IN_VIEW = "jsl_modal_open_show";
